module.exports = __webpack_public_path__ + "img/logoUser.25c33f46.jpeg";